// WaiveFeeModal — "Waive Fee" reason prompt. Sprint 5c extraction.
import React from 'react';
import { Button, Form, Input, Modal } from 'antd';

export interface WaiveFeeModalProps {
  open: boolean;
  onCancel: () => void;
  /** Called with the reason string when the user confirms. */
  onSubmit: (reason: string) => Promise<void> | void;
}

export const WaiveFeeModal: React.FC<WaiveFeeModalProps> = ({ open, onCancel, onSubmit }) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Waive Fee"
      open={open}
      onCancel={handleCancel}
      footer={null}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(v: { reason: string }) => onSubmit(v.reason)}
      >
        <Form.Item
          name="reason"
          label="Waiver Reason"
          rules={[{ required: true, message: 'Please provide a reason' }]}
        >
          <Input.TextArea rows={3} placeholder="Enter reason for waiving this fee" />
        </Form.Item>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit">Confirm Waive</Button>
        </div>
      </Form>
    </Modal>
  );
};
